const pagesList = [
  {
    name: "בית",
    path: "/",
  },
  {
    name: "בית המדרש",
    path: "/BeitHamidrash",
  },
  {
    name: "על הישיבה",
    path: "/About",
  },
  {
    name: ' שבושי"ם',
    path: "/Shvushim",
  },
  {
    name: " בוגרים",
    path: "/Bogrim",
  },
  {
    name: "הוצאה לאור",
    path: "/Publishing",
  },
  {
    name: "צור קשר",
    path: "/Contact",
  },
];

export default pagesList;
